import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Button, Stack } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import appcolors from "../../constants/Colors";
import { t } from "i18next";

const BackButton = ({ handleBack }) => {
  const navigate = useNavigate();
  return (
    <Stack width={"100%"}>
      <Button
        onClick={() => {
          if (handleBack) {
            handleBack();
          } else {
            navigate(-1);
          }
        }}
        disableRipple
        variant="outlined"
        sx={{
          border: "none",
          height: "10px",
          width: "100px",
          color: appcolors.slateGrey,
          "&:hover": {
            border: "none",
            backgroundColor: "transparent",
          },
        }}
        startIcon={<ArrowBackIosIcon htmlColor={appcolors.slateGrey} />}
      >
        {t('goBack')}
      </Button>
    </Stack>
  );
};

export default BackButton;
